import { StatusApprovalsEnum } from '@project-management-system/shared-models';
import { Entity, PrimaryGeneratedColumn, Column, CreateDateColumn, Unique, OneToMany } from 'typeorm';
import { FabricTrimsMaster } from './fabric-trims-master.entity';
import { MeasurementChartMonths } from './measurement-chart-6-12-months.entity';
import { MeasurementChart2T } from './measurement-chart-2t.entity';
import { ApparelArticleMasterVersions } from '../tech-pack-versions/apparel-article-masters-versions.entity';

@Entity('apparel_article_master')
@Unique(["approvalStatus", "techPack"])
export class ApparelArticleMaster {
    @PrimaryGeneratedColumn()
    id: number;

    @Column({ name: 'category', type: 'varchar', length: 255 })
    category: string;

    @Column({ name: 'sub_category', type: 'varchar', length: 255 })
    subCategory: string;

    @Column({ name: 'tech_pack', type: 'varchar', length: 255 })
    techPack: string;

    @Column({ name: 'season', type: 'varchar', length: 50 })
    season: string;

    @Column({ name: 'vendor', type: 'varchar', length: 255 })
    vendor: string;

    @Column({ name: 'department', type: 'varchar', length: 255 })
    department: string;

    @Column({ name: 'brand', type: 'varchar', length: 255 })
    brand: string;

    @Column({ name: 'collection', type: 'varchar', length: 255 })
    collection: string;

    @Column({ name: 'design_bom', type: 'varchar', length: 255 })
    designBOM: string;

    @Column({ name: 'bom_number', type: 'varchar', length: 50 })
    bomNumber: string;

    @Column({ name: 'status', type: 'varchar', length: 50 })
    status: string;

    @Column({ name: 'flow', type: 'varchar', length: 50 })
    flow: string;

    @Column({ name: 'remarks', type: 'text' })
    remarks: string;

    @Column({ name: 'buyer', type: 'varchar', length: 50 })
    buyer: string;

    @Column({ name: 'created', type: 'date' })
    created: Date;

    @Column({ name: 'modified', type: 'date' })
    modified: Date;

    @Column({ name: 'approval_status', nullable: false, type: 'enum', enum: StatusApprovalsEnum, default: StatusApprovalsEnum.PENDING_WITH_HEAD_OF_TECHNICAL })
    approvalStatus: StatusApprovalsEnum;


    @Column({ name: 'role', type: 'varchar', length: 50 })
    role: string;

    @Column({ name: 'raw_data', type: 'text' })
    rawData: string;

    @OneToMany(() => FabricTrimsMaster, (ft) => ft.apparelArticleId)
    fabricId: FabricTrimsMaster[];

    @OneToMany(() => MeasurementChart2T, (ft) => ft.apparelArticleId)
    measurementChart2t: MeasurementChart2T[];

    @OneToMany(() => MeasurementChartMonths, (ft) => ft.apparelArticleId)
    measurementChartMonths: MeasurementChartMonths[];

    @OneToMany(() => ApparelArticleMasterVersions, (ft) => ft.apparelArticleId)
    versionApparelArticle: ApparelArticleMasterVersions[];


    @CreateDateColumn({
        name: "created_at",
    })
    createdAt: string;

    @Column("varchar", {
        nullable: true,
        length: 40,
        name: "created_user",
    })
    createdUser: string | null;

    @Column("varchar", {
        nullable: true,
        length: 40,
        name: "updated_user",
    })
    updatedUser: string | null;

    @CreateDateColumn({
        name: "updated_at",
    })
    updatedAt: string;
}
